import { z } from 'zod';

const text = z.string().nullish();
export const billingSchema = z.looseObject({
  id: z.string(),
  walletCode: z.number(),
  documentNumber: text,
  amount: z.number(),
  description: text,
  discount: z.union([z.number(), z.string()]).nullish(),
  dueDate: text,
  createdAt: text,
  walletNumber: text,
  ourNumber: text,
  tags: z.array(z.string()).nullish(),
  statusValue: z.string(),
  statusDisplay: text,
  registered: z.boolean(),
  paidAmount: z.number().nullish(),
  pendingAmount: z.number().nullish(),
  creditTypeValue: text,
  creditTypeDisplay: text,
  discountLimitDate: text,
  lastPaymentDate: text,
  billingSettingId: text,
  billingSettingDisplay: text,
  communicationSettingId: text,
  communicationSettingDisplay: text,
  settlementChannelValueDisplay: text,
  paymentModality: text,
  installmentId: text,
  errorMessage: text,
  payer: z
    .looseObject({
      name: text.meta({ pii: 'name' }),
      registrationNumber: text.meta({ pii: 'document' }),
      email: text.meta({ pii: 'email' }),
      addressName: text.meta({ pii: 'address' }),
      zipCode: text.meta({ pii: 'address' }),
    })
    .nullish(),
  guarantor: z
    .looseObject({
      name: text.meta({ pii: 'name' }),
      registrationNumber: text.meta({ pii: 'document' }),
    })
    .nullish(),
  bankSlip: z
    .looseObject({
      id: text,
      barCode: text.meta({ pii: 'document' }),
      statusRegisterValue: text,
      statusSettlementValue: text,
    })
    .nullish(),
  fileInstructionLines: z.array(z.unknown()).nullish(),
  fileConfirmationLines: z.array(z.unknown()).nullish(),
});
export const billingPageSchema = z.looseObject({
  data: z.array(billingSchema),
  page: z.number(),
  totalItems: z.number(),
  totalPages: z.number(),
});
export type Billing = z.infer<typeof billingSchema>;
export type BillingParams = Record<string, unknown>;
export type BillingPatch = Pick<
  Billing,
  | 'documentNumber'
  | 'description'
  | 'amount'
  | 'dueDate'
  | 'discount'
  | 'payer'
  | 'guarantor'
  | 'tags'
  | 'creditTypeValue'
  | 'discountLimitDate'
>;
export const pixSchema = z.looseObject({
  settledAt: text,
  cancelledAt: text,
  billingId: z.string(),
  qrCode: z.string().meta({ pii: 'document' }),
  txId: z.string().meta({ pii: 'document' }),
  amount: z.number(),
  dueDate: z.string(),
  status: z.string(),
  statusDisplay: z.string(),
});
export type BillingPix = z.infer<typeof pixSchema>;
